import { Card, Space, Tag, Typography } from 'antd'
import { HeartOutlined, HeartTwoTone } from '@ant-design/icons'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import * as Cesium from '@cesiumgs/cesium-analytics'
import useStore from '@/hooks/useStore'
import { IUpdateFcltLike } from '@/service/rightNavCtrl'

import './InfoCard.less'

const { Title, Text } = Typography

function InfoCard(props) {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const facilityStore = useStore('facilityStore')
  const mapStore = useStore('mapStore')
  const { FacilityLeaseInfo = {} } = facilityStore
  const { isFromUrlId, sggCd } = props

  useEffect(() => {
    const { isFromUrlId } = props
    if (isFromUrlId) {
      const find = facilityStore.SearchResults.find(item => item.idlFcltUnqNo === isFromUrlId)
      if (find) {
        facilityInfo(isFromUrlId)
      }
    }
  }, [isFromUrlId])

  const favorites = () => {
    const { idlFcltUnqNo = '' } = FacilityLeaseInfo

    const id = localStorage.getItem('JSESSIONID') || ''
    const obj = {
      idlFcltUnqNo,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      apiKey: window.SystemConfig.facilityApiKey,
    }
    IUpdateFcltLike(obj).then((res) => {
      if (res.code === 200) {
        if (facilityStore.searchParams) {
          facilityStore.searchFacility(facilityStore.searchParams)
        }
      }
    })
      .catch((err) => {
        console.log('err', err)
      })
  }

  const favoritesIcon = () => {
    const { like = false } = FacilityLeaseInfo
    if (like) {
      return <HeartTwoTone twoToneColor="#eb2e95" />
    }
    else {
      return <HeartOutlined style={{ color: '#9a9c9e' }} />
    }
  }
  const tagColor = (str) => {
    let color = ''
    switch (str) {
      case '창업':
        color = '#2E60E9'
        break
      case '문화예술':
        color = '#11B558'
        break
      case '워케이션':
        color = '#FF7602'
        break
      case '기타':
        color = '#0DC9BB'
        break
      case '전체':
        color = '#22252A'
        break
    }
    return color
  }

  const facilityInfo = (isFromUrlId = null) => {
    const { idlFcltUnqNo = '' } = FacilityLeaseInfo
    const { posFclt = '' } = FacilityLeaseInfo
    console.log(`posFclt : ${posFclt}`)
    const id = localStorage.getItem('JSESSIONID') || ''
    const id2 = isDev ? `${window.SystemConfig.facilitySessionId}` : id
    facilityStore.getFacilityLeaseInfo(isFromUrlId || idlFcltUnqNo, id2)
    facilityStore.setIdlFcltUnqNo(isFromUrlId || idlFcltUnqNo)
    facilityStore.setClickedSggCdValue(sggCd)
    facilityStore.justClickToHide()
    // load 3dtiles
    facilityStore.load3dTiles(mapStore.viewer, isFromUrlId || idlFcltUnqNo)

    if (posFclt) {
      window.cviewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(posFclt.x, posFclt.y, 200),
        offset: {
          heading: Cesium.Math.toRadians(0),
          pitch: Cesium.Math.toRadians(-30),
          range: 100,
        },
      })
    }
  }

  return (
      <div className={'InfoCard'}>
        <Card
            style={{ width: '100%', border: 'none' }}
            cover={
              <img
                  style={{
                    height: 288,
                    width: '100%',
                    borderRadius: 'unset',
                  }}
                  src={facilityStore.FacilityLeaseInfo.imgSrc}
              />
            }
        >
          <div className={'CardTop'}>
            <div className={'TagPart'} style={{ float: 'left' }}>
              {facilityStore.FacilityLeaseInfo.tag.map((item, index) => (
                  <Tag key={index} color={tagColor(item)}>{item}</Tag>
              ))}
            </div>
            <div style={{ float: 'right' }}>
              <a
                  onClick={() => favorites()}
                  style={{ fontSize: '1.5em', lineHeight: '24px' }}
              >
                {favoritesIcon()}
              </a>
            </div>
          </div>
          <div className={'CardTitle'}>
            <Title onClick={() => facilityInfo()} level={4}>{facilityStore.FacilityLeaseInfo.name}</Title>
          </div>
          <div>
            <Text>{facilityStore.FacilityLeaseInfo.addr1}</Text>
          </div>
          <div>
            <Text>{facilityStore.FacilityLeaseInfo.addr2}</Text>
          </div>
          <div className={'card-info1'} style={{ marginTop: 10 }}>
            <div style={{ float: 'left' }}>
              면적&nbsp;&nbsp;
              <Text style={{ fontWeight: 'bold' }}>
                {facilityStore.FacilityLeaseInfo.info.split('/')[0]}
              </Text>
            </div>
            <div style={{ float: 'left', marginLeft: 20 }}>
              준공일&nbsp;&nbsp;
              <Text style={{ fontWeight: 'bold' }}>
                {facilityStore.FacilityLeaseInfo.info.split('/')[1]}
              </Text>
            </div>
            <div style={{ float: 'left', marginLeft: 20 }}>
              층수&nbsp;&nbsp;
              <Text style={{ fontWeight: 'bold' }}>
                {facilityStore.FacilityLeaseInfo.info.split('/')[2]}
              </Text>
            </div>
          </div>
          <div className={'card-info2'}>
            <div style={{ float: 'left' }}>
              주용도&nbsp;&nbsp;
              <Text style={{ fontWeight: 'bold' }}>
                {facilityStore.FacilityLeaseInfo.info.split('/')[3]}
              </Text>
            </div>
          </div>
          <div className={'TagBottom'}>
            <Space size={[0, 1]} wrap style={{ marginTop: 10 }}>
              {facilityStore.FacilityLeaseInfo.footerTag.map((item, index) => (
                 <Tag
                 key={index}
                 style={{ backgroundColor: item === 'LOD4' ? '#FFF176' : '' }}
               >
                 {item}
               </Tag>
              ))}
            </Space>
          </div>
        </Card>
      </div>
  )
}

export default observer(InfoCard)
